document.documentElement.classList.remove('no-js');

const formatMoney = (amount) => `Rs. ${(Number(amount || 0) / 100).toLocaleString('en-PK')}`;

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuButton && mobileNav) {
    const setMobileNavPosition = () => {
      const header = document.querySelector('[data-site-header]');
      const headerBottom = Math.max(0, Math.round(header?.getBoundingClientRect().bottom || 0));
      document.documentElement.style.setProperty('--mobile-nav-top', `${headerBottom}px`);
    };

    const setMenuState = (open) => {
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      menuButton.querySelector('.visually-hidden').textContent = open ? 'Close menu' : 'Open menu';
      mobileNav.hidden = !open;
      document.body.classList.toggle('menu-open', open);
      if (open) setMobileNavPosition();
    };

    menuButton.addEventListener('click', () => setMenuState(menuButton.getAttribute('aria-expanded') !== 'true'));
    mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenuState(false)));
    mobileNav.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => setMenuState(false)));
    window.addEventListener('resize', () => {
      if (menuButton.getAttribute('aria-expanded') === 'true') setMobileNavPosition();
      if (window.matchMedia('(min-width: 861px)').matches) setMenuState(false);
    });
    window.addEventListener('scroll', () => {
      if (menuButton.getAttribute('aria-expanded') === 'true') setMobileNavPosition();
    }, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
        setMenuState(false);
        menuButton.focus();
      }
    });
  }

  document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.getAttribute('data-size-guide-open'));
      if (!target) return;
      if (typeof target.showModal === 'function') target.showModal();
      else target.setAttribute('open', '');
    });
  });

  document.querySelectorAll('[data-size-guide-modal]').forEach((modal) => {
    const closeModal = () => {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    };
    modal.querySelector('[data-size-guide-close]')?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsNode = section.querySelector('[data-product-variants]');
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare-price]');
    const stock = section.querySelector('[data-product-stock]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const quantity = section.querySelector('input[name="quantity"]');

    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    const gallery = section.querySelector('[data-product-gallery]');
    const gallerySlides = [...(gallery?.querySelectorAll('[data-gallery-slide]') || [])];
    const galleryThumbs = [...(gallery?.querySelectorAll('[data-gallery-thumbnail]') || [])];
    const galleryCounter = gallery?.querySelector('[data-gallery-current]');
    let activeMediaIndex = Math.max(0, gallerySlides.findIndex((slide) => slide.classList.contains('is-active')));

    const showGalleryMedia = (nextIndex) => {
      if (!gallerySlides.length) return;
      activeMediaIndex = (Number(nextIndex) + gallerySlides.length) % gallerySlides.length;
      gallerySlides.forEach((slide, index) => {
        const isActive = index === activeMediaIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        if (!isActive) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      galleryThumbs.forEach((thumb, index) => {
        const isActive = index === activeMediaIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (galleryCounter) galleryCounter.textContent = String(activeMediaIndex + 1);
      galleryThumbs[activeMediaIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showGalleryMedia(activeMediaIndex - 1));
    gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => showGalleryMedia(activeMediaIndex + 1));
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showGalleryMedia(Number(thumb.dataset.mediaIndex)));
    });
    gallery?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showGalleryMedia(activeMediaIndex - 1);
      if (event.key === 'ArrowRight') showGalleryMedia(activeMediaIndex + 1);
    });

    if (!variantsNode || !select) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

    const refreshVariant = () => {
      const selectedOptions = [...section.querySelectorAll('[data-product-option]')].map((option) =>
        option.querySelector('.option-value.is-selected')?.dataset.optionValue
      );
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));

      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        stock.classList.add('is-sold-out');
        stock.innerHTML = 'Unavailable';
        return;
      }

      select.value = String(variant.id);
      price.textContent = formatMoney(variant.price);
      const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compare.hidden = !onSale;
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      stock.classList.toggle('is-sold-out', !variant.available);
      stock.innerHTML = variant.available ? '<span></span>In stock' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media?.id) {
        const mediaIndex = gallerySlides.findIndex((slide) => Number(slide.dataset.mediaId) === Number(variant.featured_media.id));
        if (mediaIndex >= 0) showGalleryMedia(mediaIndex);
      }
    };

    section.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const fieldset = button.closest('[data-product-option]');
        fieldset.querySelectorAll('[data-option-value]').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        refreshVariant();
      });
    });
  });

  const lightbox = document.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-product-lightbox-image]');
  document.querySelectorAll('[data-product-media-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!lightbox || !lightboxImage) return;
      lightboxImage.src = button.dataset.mediaUrl;
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    });
  });
  const closeLightbox = () => {
    if (!lightbox) return;
    if (typeof lightbox.close === 'function') lightbox.close();
    else lightbox.removeAttribute('open');
  };
  lightbox?.querySelector('[data-product-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (error) {
      // Keep the recommendations area empty if Shopify has no recommendations yet.
    }
  });
});
